import { incomingMessagesTypes } from "./data/incoming-messages-types.js";

export const classifyIncomingMessage = ({ message }) => {
  if (message?.message?.payload?.displayMessage?.body) {
    return incomingMessagesTypes.Alert;
  }

  if (
    message?.message?.content?.type ===
    incomingMessagesTypes.ConnectivityCheckToMessagingServers
  ) {
    return incomingMessagesTypes.ConnectivityCheckToMessagingServers;
  }

  if (message?.message?.type === incomingMessagesTypes.Silence) {
    return incomingMessagesTypes.Silence;
  }

  if (message?.message?.type === incomingMessagesTypes.Acknowledged) {
    return incomingMessagesTypes.Acknowledged;
  }

  return incomingMessagesTypes.NoOp;
};
